import { render, staticRenderFns } from "./form-generator.vue?vue&type=template&id=b1771e9a"
import script from "./form-generator.vue?vue&type=script&lang=js"
export * from "./form-generator.vue?vue&type=script&lang=js"
import style0 from "./form-generator.vue?vue&type=style&index=0&id=b1771e9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports